import React, { useReducer, useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import dayjs from "dayjs";
import tw from "tailwind-styled-components";
// import getSymbolFromCurrency from "currency-symbol-map";
import { toast } from "react-toastify";
import Dialog from "@mui/material/Dialog";
import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import { Zoom } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import { Text } from "@components";
import { checkBookingCondition } from "@utils";
import { setBookingDetails } from "@redux/teetime/slice";
import { removeTeetime, editCart, updateCart } from "@redux/booking/slice";
import closeIcon from "@assets/images/closeIcon.png";
import CartTimer from "./widget/cartTimer";
import theme from "../../theme";
import "./style.css";

function CartModal(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation("common");
  const { addToCartData, countDownTime, showTimer, closeModal, openModal } =
    props;
  const { cartDetails } = useSelector((store) => store.bookingReducer);
  const { clubId } = useSelector((store) => store?.teetimeReducer);
  const utc = require("dayjs/plugin/utc");
  const timezone = require("dayjs/plugin/timezone");
  dayjs.extend(utc);
  dayjs.extend(timezone);

  const [state, setState] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      sorting_CartData: [],
      isLoading: false,
      isRemovingItem: false,
      itemforRemove: null,
    }
  );

  useEffect(() => {
    let bookingData;
    if (cartDetails && cartDetails?.length > 0) {
      let arr = [...cartDetails];
      bookingData = arr.sort((a, b) => {
        const dateA = new Date(a?.teetime);
        const dateB = new Date(b?.teetime);
        return dateA - dateB;
      });
      setState({ sorting_CartData: bookingData });
    }
  }, [cartDetails]);

  // let prices =
  //   state.sorting_CartData && state.sorting_CartData?.length > 0
  //     ? state.sorting_CartData.map((a) => a?.amount)
  //     : "";
  // let totalPrice =
  //   state.sorting_CartData && state.sorting_CartData?.length > 0 && prices
  //     ? prices.reduce((acc, curr) => acc + curr)
  //     : "";

  let totalAmountArray = [];

  if (state.sorting_CartData && state.sorting_CartData?.length > 0) {
    let totalAmounts = {};

    state.sorting_CartData?.forEach((item) => {
      if (totalAmounts[item?.currency]) {
        totalAmounts[item?.currency] += item?.amount;
      } else {
        totalAmounts[item?.currency] = item?.amount;
      }
    });

    totalAmountArray = Object.keys(totalAmounts).map((currency) => ({
      amount: totalAmounts[currency],
      currency: currency,
    }));
  } else {
    totalAmountArray = [];
  }

  const changePlayers = (res, item) => {
    let localdata = JSON.parse(localStorage.getItem("C2H_LocalCartData"));

    let upd_obj = localdata?.map((obj) => {
      if (
        obj?.teeId === item?.teeId &&
        obj?.teetime === item?.teetime &&
        obj?.clubId === item?.clubId
      ) {
        obj.players = Number(res);
        obj.amount = item?.allPrice[Number(res) - 1]?.price?.amount;
        obj.currency = item?.allPrice[Number(res) - 1]?.price?.currency;
      }
      return obj;
    });

    dispatch(editCart(upd_obj));
  };

  const removeItem = (e) => {
    setState({ isRemovingItem: true });
    let remove_cart = cartDetails?.filter(
      (item) =>
        item.teeId !== e.teeId ||
        item.teetime !== e.teetime ||
        item.clubId !== e.clubId ||
        item.courseId.courseId !== e.courseId.courseId
    );
    setState({ itemforRemove: e });
    setTimeout(() => {
      setState({ isRemovingItem: false });

      dispatch(removeTeetime(remove_cart));
      if (cartDetails?.length === 1) {
        closeModal();
        if (window.location.pathname === "/checkout") {
          navigate(-1);
        }
      }
    }, 500);
  };

  const goCheckout = async () => {
    setState({ isLoading: true });
    let isBooked = await checkBookingCondition(cartDetails, t, dispatch);

    if (isBooked.success === false) {
      setState({ isLoading: false });
      toast.error(isBooked.message, {});
      return;
    } else {
      setState({ isLoading: false });
      const bookingData = {
        bookings: [...cartDetails],
        clubId: clubId,
      };
      closeModal();
      dispatch(setBookingDetails(bookingData));
      navigate("/checkout");
    }
  };

  const closeCartModal = () => {
    dispatch(updateCart({ removeItem: true }));
    closeModal();
    if (window.location.pathname === "/checkout") {
      navigate(-1);
    }
  };

  const Title = () => {
    return (
      <div className="flex flex-row items-center justify-between w-full h-auto my-4">
        <Text className="text-2xl text-black0 font-bold font-sfprodisplay text-center">
          {t("teeTime.teeTimeCart")}
        </Text>
        <button
          onClick={closeModal}
          className="w-[40px] h-[40px] bg-white rounded-full flex items-center justify-center opacity-80 hover:opacity-100"
        >
          <img src={closeIcon} className="w-[35px] h-[35px]" alt="" />
        </button>
      </div>
    );
  };

  const DetailText = (props) => {
    return (
      <div className={`${props.divClass}`}>
        <p className={` ${props.txtClass}`}>{props.value}</p>
      </div>
    );
  };

  const HorizontalSelect = ({ item, handlePlayers }) => {
    const [showOptions, setShowOptions] = useState(false);
    const [selected, setSelected] = useState(item?.players || 1);
    const dropdownRef = useRef(null);

    const handleSelect = (value) => {
      setSelected(value);
      setShowOptions(false);
      handlePlayers(value, item);
    };

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (
          dropdownRef.current &&
          !dropdownRef.current.contains(event.target)
        ) {
          setShowOptions(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, []);

    return (
      <div className="relative inline-block" ref={dropdownRef}>
        <button
          onClick={() => setShowOptions((prev) => !prev)}
          className="px-2 py-1 bg-buttonColor rounded hover:opacity-80 flex flex-row items-center justify-end gap-x-1 min-w-[53px]"
        >
          <p className="text-buttonTextColor">{selected}</p>
          {showOptions ? (
            <ArrowDropUpIcon sx={{ color: theme.colors.buttonTextColor }} />
          ) : (
            <ArrowDropDownIcon sx={{ color: theme.colors.buttonTextColor }} />
          )}
        </button>

        {showOptions && (
          <div className="absolute right-0 z-10 mt-2 bg-white shadow rounded flex space-x-2 p-2 border border-gray-400">
            {Array.from(Array(item?.availablePlayer || 4), (_, i) => i + 1).map(
              (num) => (
                <div
                  key={num}
                  onClick={() => handleSelect(num)}
                  className={`px-3 py-1 bg-buttonColor rounded cursor-pointer  text-white ${
                    selected === num
                      ? "hover:cursor-default opacity-50"
                      : "hover:cursor-pointer hover:opacity-80 "
                  }`}
                >
                  {num}
                </div>
              )
            )}
          </div>
        )}
      </div>
    );
  };

  const CountCircle = ({ selected, value, handleClick, item }) => {
    return (
      <div
        onClick={handleClick}
        className={`h-8 w-8 rounded-full flex justify-center items-center  ${
          selected
            ? "bg-buttonColor hover:cursor-default"
            : "border border-midGray hover:border-buttonColor hover:cursor-pointer"
        }`}
      >
        <Text className={`${selected ? "text-white" : "text-black"}`}>
          {value}
        </Text>
      </div>
    );
  };

  const BookingDetails = () => {
    return (
      <div className="w-full h-auto pb-2  ">
        {state.sorting_CartData?.length > 0 ? (
          state.sorting_CartData?.map((item, index) => (
            <React.Fragment key={index}>
              <div className="flex flex-col py-2 px-4 mt-1 mb-4 md:mx-6 mx-3 bg-white rounded-md border shadow-[0px_0px_15px_0px_#E5E2FF]">
                <div className="w-full h-auto flex flex-row items-center justify-between">
                  <div className="w-full h-auto flex flex-col">
                    <div className="flex flex-row items-center justify-between">
                      <DetailText
                        divClass="w-full truncate"
                        txtClass="font-semibold sm:text-[16px] text-[14px] truncate"
                        value={item?.clubName}
                      />
                      {window.location.pathname !== "/checkout" ? (
                        <>
                          {" "}
                          {state.isRemovingItem &&
                          item.teeId === state.itemforRemove.teeId &&
                          item.teetime === state.itemforRemove.teetime &&
                          item.clubId === state.itemforRemove.clubId &&
                          item.courseId.courseId ===
                            state.itemforRemove.courseId.courseId ? (
                            <div className="flex justify-center mt-2">
                              <div className=" w-6 h-6 border-4 border-buttonColor border-t-buttonLightColor border-solid rounded-full animate-spin" />
                            </div>
                          ) : (
                            <Tooltip
                              title={t("teeTime.remove_Tee")}
                              arrow
                              TransitionComponent={Zoom}
                            >
                              <IconButton
                                onClick={() => removeItem(item)}
                                sx={{
                                  color: theme.colors.buttonColor,
                                  // textTransform: "capitalize",
                                  // fontSize: "16px",
                                }}
                              >
                                {/* {t("teeTime.remove")} */}
                                <DeleteIcon
                                  sx={{ color: theme.colors.buttonColor }}
                                />
                              </IconButton>
                            </Tooltip>
                          )}
                        </>
                      ) : (
                        <></>
                      )}
                    </div>
                    <DetailText
                      divClass=""
                      txtClass="opacity-70 font-medium sm:text-[14px] text-[13px]"
                      value={dayjs(item?.teetime).format("DD/MM/YY - HH:mm")}
                    />
                  </div>
                </div>
                <div className="w-full h-[1px] opacity-30 bg-[gray] my-2"></div>

                <div className="w-full h-auto flex flex-row items-start justify-between">
                  <div className="w-auto h-auto flex flex-col gap-y-[4px]">
                    <DetailText
                      txtClass="opacity-70 sm:text-[14px] text-[13px]"
                      value={"Course"}
                    />
                    <DetailText
                      txtClass="sm:text-[14px] text-[13px] font-semibold"
                      value={item?.course}
                    />
                  </div>
                  <div className="w-auto h-auto flex flex-col gap-y-[4px] items-end">
                    <DetailText
                      txtClass="opacity-70 sm:text-[14px] text-[13px]"
                      value={t("teeTime.player")}
                    />
                    {window.location.pathname === "/checkout" ? (
                      <DetailText
                        txtClass="sm:text-[14px] text-[13px]"
                        value={item?.players}
                      />
                    ) : (
                      // <input
                      //   type="number"
                      //   min={1}
                      //   max={item?.availablePlayer ? item?.availablePlayer : 4}
                      //   value={item?.players}
                      //   style={{
                      //     width: "30px",
                      //     border: "none",
                      //     outline: "none",
                      //     backgroundColor: "white",
                      //   }}
                      //   id="myNumber"
                      //   className="number_Input"
                      //   onChange={(event) =>
                      //     changePlayers(event.target.value, item)
                      //   }
                      // ></input>

                      // <select
                      //   id="player"
                      //   className="w-auto hover:cursor-pointer"
                      //   defaultValue={item?.players}
                      //   onChange={(e) => changePlayers(e?.target?.value, item)}
                      // >
                      //   {Array.from(
                      //     Array(item?.availablePlayer || 4),
                      //     (_, index) => index + 1
                      //   )?.map((e, i) => (
                      //     <option className="text-center" key={i}>
                      //       {e}
                      //     </option>
                      //   ))}
                      // </select>

                      // <HorizontalSelect
                      //   item={item}
                      //   handlePlayers={changePlayers}
                      // />

                      <div className="flex w-auto h-[40px] text-center justify-start gap-x-2">
                        {Array.from(
                          Array(item?.availablePlayer || 4),
                          (_, index) => index + 1
                        )?.map((e, i) => (
                          <CountCircle
                            handleClick={() => changePlayers(e, item)}
                            selected={item?.players === e}
                            value={e}
                            key={i}
                          />
                        ))}
                      </div>
                    )}
                  </div>
                  {/* <div className="w-auto h-auto flex flex-col gap-y-[4px]">
                    <DetailText
                      txtClass="opacity-70 sm:text-[14px] text-[13px]"
                      value={t("teeTime.price")}
                    />
                    <div>
                      <sup className="font-black lg:text-[11px] text-[9px]">
                        {item?.currency?.length > 1
                          ? getSymbolFromCurrency(item?.currency)
                          : item?.currency}
                      </sup>
                      <span className="text-[16px] font-black">
                        {Math.round(item?.amount)}
                      </span>
                    </div>
                  </div> */}
                </div>
              </div>

              {/* {state.sorting_CartData?.length - 1 === index ? (
                <div className="w-full h-auto flex flex-row items-start pb-4 px-2">
                  <div className="w-[50%] h-auto">
                    <p className="font-semibold">{t("teeTime.total")}</p>
                  </div>
                  <div className="w-[50%] h-auto text-end">
                    {totalAmountArray?.map((amount, index2) => (
                      <div
                        className="w-full flex flex-col gap-y-2"
                        key={index2}
                      >
                        <div>
                          <sup className="font-bold lg:text-[11px] text-[9px]">
                            {getSymbolFromCurrency(amount?.currency)}
                          </sup>
                          <span className="text-[16px] font-bold">
                            {Math.round(amount?.amount)}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                ""
              )} */}
            </React.Fragment>
          ))
        ) : (
          <></>
        )}
      </div>
    );
  };

  return (
    <div className=" relative">
      <Dialog
        open={openModal}
        onClose={closeModal}
        TransitionComponent={Zoom}
        PaperProps={{
          sx: {
            margin: "0%",
            borderRadius: "10px",
          },
        }}
        BackdropProps={{
          style: {
            backgroundColor: "rgba(0, 0, 0, 0.8)",
          },
        }}
      >
        {addToCartData?.length > 0 ? (
          <>
            <div className="w-full h-auto flex flex-col items-start justify-start md:px-6 px-2">
              <div className="w-full h-auto flex flex-row justify-between items-center pt-6 pb-3">
                <p className={titleTxt}>{t("teeTime.teeTime_Cart")}</p>
                <Button
                  onClick={() => closeCartModal()}
                  variant="contained"
                  sx={{
                    color: theme.colors.buttonTextColor,
                    backgroundColor: theme.colors.buttonColor,
                    textTransform: "none",
                    fontSize: "16px",
                    fontWeight: "bold",
                    "&:hover": {
                      backgroundColor: theme.colors.buttonColor,
                      opacity: 0.8,
                    },
                  }}
                >
                  {t("teeTime.clearCart")}
                </Button>
              </div>
              {showTimer && window.location.pathname !== "/checkout" && (
                <CartTimer removeAllItems={props?.removeAllItems} />
              )}
            </div>
            <Content>
              <BookingDetails />
            </Content>
            {window.location.pathname === "/checkout" ? (
              <></>
            ) : (
              <>
                <div className="w-full h-auto flex items-center justify-center md:px-6 px-2">
                  <button
                    disabled={state.isLoading}
                    className="w-full md:px-6 px-[3px] rounded-full h-auto bg-buttonColor py-2 hover:opacity-70"
                    onClick={() => goCheckout()}
                  >
                    {state.isLoading ? (
                      <div className="flex justify-center">
                        <div className=" w-6 h-6 border-4 border-white/10 border-t-white border-solid rounded-full animate-spin" />
                      </div>
                    ) : (
                      <span className="text-[18px] font-bold text-buttonTextColor">
                        {t("teeTime.checkout_Pay")}
                      </span>
                    )}
                  </button>
                </div>

                <div className="w-full h-auto flex flex-row items-center justify-center gap-x-[2px] mt-[10px] md:px-6 px-2 pb-4">
                  <Text className="text-sm text-white255 font-sfprodisplay text-center"></Text>
                  <button onClick={closeModal}>
                    <span className="text-[#004996] txt-underline-animation font-bold">
                      {t("teeTime.continue")}
                    </span>
                  </button>
                </div>
              </>
            )}
          </>
        ) : (
          <Content className="flex flex-col items-center justify-center md:px-6 px-2">
            <Title />
            <button className="w-full h-auto p-2" onClick={closeModal}>
              {t("teeTime.no_Item")}
            </button>
          </Content>
        )}
      </Dialog>
    </div>
  );
}

const Content = tw.div`
md:w-[500px] sm:w-[460px] xsm:w-[350px] w-full 
min:w-[300px]
h-auto max-h-[530px]
pb-4
pt-2
bg-[#f9f9f9]
rounded-xl
overflow-x-hidden overflow-y-auto custom-scroll
`;

const titleTxt = `
text-[20px] 
text-[black]
font-bold 
`;

export default CartModal;
